import { render, staticRenderFns } from "./CalendarQuestion.vue?vue&type=template&id=2d0ea40a"
import script from "./CalendarQuestion.vue?vue&type=script&lang=js"
export * from "./CalendarQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports